import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

export default function MusicPlayer() {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [, setReady] = useState(false);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.volume = 0.18;

    const tryPlay = async () => {
      try {
        await audio.play();
        setPlaying(true);
        setReady(true);
      } catch (error) {
        // Autoplay blocked by the browser — start on first user gesture instead
        console.info("Autoplay blocked; waiting for user interaction:", error?.name || error);
        const start = async () => {
          try {
            await audio.play();
            setPlaying(true);
          } catch (playError) {
            console.warn("Music playback could not start:", playError);
          }
          setReady(true);
          window.removeEventListener("pointerdown", start);
          window.removeEventListener("keydown", start);
        };
        window.addEventListener("pointerdown", start, { once: true });
        window.addEventListener("keydown", start, { once: true });
      }
    };
    tryPlay();

    return () => {
      audio.pause();
    };
  }, []);

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (playing) {
      audio.pause();
      setPlaying(false);
    } else {
      audio.play().then(() => setPlaying(true)).catch((error) => {
        console.warn("Could not play music:", error);
      });
    }
  };

  return (
    <>
      <audio ref={audioRef} src="/gymnopedie.mp3" loop preload="auto" />
      <button
        data-testid="music-toggle-btn"
        onClick={toggle}
        aria-label={playing ? "Mute background music" : "Play background music"}
        title={playing ? "Mute music" : "Play soft music"}
        className="fixed bottom-5 right-5 z-50 flex items-center gap-2 bg-[#6A0DAD] text-white rounded-full pl-3 pr-4 py-2.5 shadow-lg hover:bg-[#58098F] transition-colors"
      >
        <span className="relative grid place-items-center">
          {playing ? <Volume2 size={18} /> : <VolumeX size={18} />}
          {playing && (
            <span className="absolute -inset-1 rounded-full border border-white/40 animate-ping" />
          )}
        </span>
        <span className="hidden sm:inline font-heading text-sm font-semibold">
          {playing ? "Music on" : "Music off"}
        </span>
      </button>
    </>
  );
}
